import { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Spinner } from '@viana-demos/ui';
import { DemoShell } from '@core/layout';
import { DemoLauncher } from './pages/DemoLauncher';
import { NotFound } from './pages/NotFound';
import { findDemo } from './registry';

/** Mounts the selected demo's own routes under /demo/:demoId/*. */
function DemoHost() {
  const { demoId } = useParams<{ demoId: string }>();
  const demo = findDemo(demoId);

  if (!demo) return <Navigate to="/" replace />;

  const DemoRoutes = demo.Routes;
  return (
    <DemoShell title={demo.title}>
      <Suspense
        fallback={
          <div className="flex flex-1 items-center justify-center">
            <Spinner className="h-8 w-8" />
          </div>
        }
      >
        <DemoRoutes />
      </Suspense>
    </DemoShell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <DemoShell>
              <DemoLauncher />
            </DemoShell>
          }
        />
        <Route path="/demo/:demoId/*" element={<DemoHost />} />
        <Route
          path="*"
          element={
            <DemoShell>
              <NotFound />
            </DemoShell>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
